import { Controller } from '@hotwired/stimulus'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['tabs']

    tabs: HTMLElement[] = []
    contents: HTMLElement[] = []

    connect() {
        const tabs = this.element.querySelectorAll('.tab') as NodeListOf<HTMLElement>
        if (!tabs) {
            return
        }

        this.tabs = Array.from(tabs)
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.onTabClick.bind(this))

            if (tab.classList.contains('active')) {
                this.moveUnderline(tab)
            }
        })
    }

    disconnect() {
        this.tabs.forEach((tab) => {
            tab.removeEventListener('click', this.onTabClick.bind(this))
        })
    }

    moveUnderline(currentTab: HTMLElement) {
        const tabsWrapper = currentTab?.parentElement
        if (!tabsWrapper) {
            return
        }

        const selector = tabsWrapper.querySelector('.tabs__selector') as HTMLElement
        if (!selector) {
            return
        }

        if (typeof currentTab.offsetLeft === 'number' && typeof currentTab.offsetWidth === 'number') {
            selector.style.left = `${currentTab.offsetLeft}px`
            selector.style.width = `${currentTab.offsetWidth}px`
        }
    }

    updateUnderLine() {
        this.tabs.forEach((tab) => {
            if (tab.classList.contains('active')) {
                this.moveUnderline(tab as HTMLElement)
            }
        })
    }

    onTabClick(event: Event) {
        event.preventDefault()
        event.stopPropagation()

        const currentTab = event.target as HTMLAnchorElement
        if (currentTab.classList.contains('active')) {
            return
        }

        const tabsWrapper = currentTab?.parentElement
        const tabDataLink = currentTab?.href

        if (!tabDataLink || !tabsWrapper?.id) {
            return
        }

        const tabDataId = tabDataLink.split('#')[1]
        const tabDataWrapper = document.querySelector(`[data-tabs=${tabsWrapper?.id}]`)

        if (!tabDataWrapper || !tabDataId) {
            return
        }

        const tabContentBlocks = tabDataWrapper.querySelectorAll('.tab-data') as NodeListOf<HTMLElement>
        const tabsInGroup = tabsWrapper.querySelectorAll('.tab') as NodeListOf<HTMLElement>

        if (!tabContentBlocks || !tabContentBlocks.length || !tabsInGroup || !tabsInGroup.length) {
            return
        }

        tabContentBlocks.forEach((c: HTMLElement) => {
            if (c.dataset.content === tabDataId) {
                c.classList.remove('hidden')
            } else {
                c.classList.add('hidden')
            }
        })

        tabsInGroup.forEach((t: HTMLElement) => {
            if (t === currentTab) {
                t.classList.add('active')
                this.moveUnderline(currentTab)
            } else {
                t.classList.remove('active')
            }
        })
    }
}
